import { InstantShipOrderRecordType, InstantShipPostPayInterval } from "@/services/api/instantShip";

export const instantShipPostPayIntervalOptions = [
    { value: InstantShipPostPayInterval.TEN_MINUTES, label: "付款10分钟后" },
    { value: InstantShipPostPayInterval.TWENTY_MINUTES, label: "付款20分钟后" },
    { value: InstantShipPostPayInterval.THIRTY_MINUTES, label: "付款30分钟后" },
    { value: InstantShipPostPayInterval.FORTY_MINUTES, label: "付款40分钟后" },
    { value: InstantShipPostPayInterval.FIFTY_MINUTES, label: "付款50分钟后" },
    { value: InstantShipPostPayInterval.SIXTY_MINUTES, label: "付款60分钟后" },
];

export const instantShipPostPayIntervalNameMap: Record<InstantShipPostPayInterval, string> =
    instantShipPostPayIntervalOptions.reduce((result, option) => {
        result[option.value] = option.label;
        return result;
    }, {} as Record<InstantShipPostPayInterval, string>);

export const instantShipOrderRecordTypeNameMap: Record<InstantShipOrderRecordType, string> = {
    [InstantShipOrderRecordType.SUCCESS]: "成功",
    [InstantShipOrderRecordType.GENERATE_FAIL]: "取号失败",
    [InstantShipOrderRecordType.SHIP_FAIL]: "发货失败",
    [InstantShipOrderRecordType.SKIP]: "已跳过",
};
